import React,{useEffect, useState} from 'react'
import {Row, Col, Nav, Accordion,} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { getSchool } from '../../actions/schoolsActions'
import { Link, useLocation } from 'react-router-dom'
import Version from '../../version'


export default function MenuSchool() {
    const { t } = useTranslation()
	const {client, logout} = useAuth()
    const dispatch = useDispatch()
	const location = useLocation()

	const {school, schooluser} = useSelector(state=>state.schools)

	const [imageAux, setImage] = useState(null)

	const isactiveProcessesActive = (path) => {
		let isActive = false

		if (location.pathname === '/school/activeprocesses') {
			isActive = true
		}

		if (/^\/school\/overviewprocess\/[a-zA-Z0-9]+\/candidates$/.test(path)) {
			isActive = true
		}

		if (/^\/school\/overviewprocess\/[a-zA-Z0-9]+\/precandidates$/.test(path)) {
			isActive = true
		}

		return isActive
	}

	useEffect(() => {
        if(client){
            dispatch(getSchool(client?.id))
        }
    },[dispatch, t, client])

    useEffect(() => {
        if(school){
            setImage(schooluser?.image)
        }
    },[school, schooluser])

  	return (
		<>
			<Row>
				<Col xs='12' className='d-flex justify-content-center mt-3 mb-2'>
					<div className='avatar'>
						{imageAux
							?
								<img className="img-profile" alt="Preview" src={typeof imageAux === 'string' ? imageAux : URL.createObjectURL(imageAux)} />
							:
								<div className="img-profile"></div>
						}
					</div>
				</Col>
				<Col className='text-center'>
						{school?.firstname} {school?.lastname}
				</Col>
			</Row>
			<Row>
				<Col className='d-flex justify-content-center align-items-center gap-2'>
					<Link to="/school/config" className={`nav-link ${location.pathname === '/school/config' ? 'active' : ''}`}>
						<img src='/images/config.svg' alt="Config" />
					</Link>
					<Link to="/" onClick={logout}>
						<i className="fa-solid fa-arrow-right-from-bracket color-primary"></i>
					</Link>
				</Col>
			</Row>
			<Row style={{marginTop: '100px'}}>
				<Col className='p-0'>
					<Nav className="flex-column">
						<Nav.Item>
							<Link to="/school/dashboard" className={`nav-link ${location.pathname === '/school/dashboard' ? 'active' : ''}`}>
								<img src="/images/menus/home.svg" alt="Icono Mi Perfil" className='me-3'/>
								{t('menus.home')}
							</Link>
						</Nav.Item>
						<Accordion defaultActiveKey="0">
							<Accordion.Item eventKey="0" className="ps-1">
								<Accordion.Header>
									<img src="/images/menus/user.svg" alt="Icono Mi Perfil" className='me-3'/>
									{t('menus.school')}
								</Accordion.Header>
								<Accordion.Body>
									<Nav className="flex-column">
										<Nav.Item>
											<Link to="/school/profile" className={`nav-link ${location.pathname === '/school/profile' ? 'active' : ''}`}>
												{t('menus.profile')}
											</Link>
										</Nav.Item>
										<Nav.Item>
											<Link to="/school/staff" className={`nav-link ${location.pathname === '/school/staff' ? 'active' : ''}`}>
												{t('menus.staff')}
											</Link>
										</Nav.Item>
									</Nav>
								</Accordion.Body>
							</Accordion.Item>
						</Accordion>
						<Nav.Item>
							<Accordion defaultActiveKey="0">
								<Accordion.Item eventKey="0" className="ps-1">
									<Accordion.Header>
										<img src="/images/config.svg" alt="Icono Mi Perfil" className='me-3'/>
										{t('menus.processes')}
									</Accordion.Header>
									<Accordion.Body>
										<Nav defaultActiveKey="/config" className="flex-column">
											{/* <Nav.Item>
												<Link to="/school/startprocess" className={`nav-link ${location.pathname === '/school/startprocess' ? 'active' : ''}`}>
													{t('menus.startprocess')}
												</Link>
											</Nav.Item> */}
											<Nav.Item>
												<Link to="/school/programprocess" className={`nav-link ${location.pathname === '/school/programprocess' ? 'active' : ''}`}>
													{t('menus.programprocess')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link to="/school/activeprocesses" className={`nav-link ${isactiveProcessesActive(location.pathname) ? 'active' : ''}`}>
													{t('menus.activeprocesses')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link to="/school/completedprocesses" className={`nav-link ${location.pathname === '/school/completedprocesses' ? 'active' : ''}`}>
													{t('menus.completedprocesses')}
												</Link>
											</Nav.Item>
										</Nav>
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						</Nav.Item>
						{/* <Accordion defaultActiveKey="0">
							<Accordion.Item eventKey="0" className="ps-1">
								<Accordion.Header>
									<img src="/images/menus/subscription.svg" alt="Icono Mi Perfil" className='me-3'/>
									{t('menus.subscription')}
								</Accordion.Header>
								<Accordion.Body>
									<Nav className="flex-column">
										<Nav.Item>
											<Link to="/school/subscription" className={`nav-link ${location.pathname === '/school/subscription' ? 'active' : ''}`}>
												{t('menus.subscription')}
											</Link>
										</Nav.Item>
										<Nav.Item>
											<Link to="/school/paymentMethods" className={`nav-link ${location.pathname === '/school/paymentMethods' ? 'active' : ''}`}>
												{t('menus.paymentMethods')}
											</Link>
										</Nav.Item>
									</Nav>
								</Accordion.Body>
							</Accordion.Item>
						</Accordion> */}
						<Nav.Item>
							<Link to="/school/database/favourites" className='nav-link'>
								<img src="/images/menus/database.svg" alt="Data base" className='me-3'/>
								{t('menus.database')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link to="/school/tickets" className='nav-link'>
								<img src="/images/menus/ticket.svg" alt="Tickets" className='me-3'/>
								{t('menus.tickets')}
							</Link>
						</Nav.Item>
					</Nav>
				</Col>
			</Row>
			<Row>
				<Col className='text-center my-3'>
					<Version />
				</Col>
			</Row>
		</>
	)
}